export default __webpack_public_path__ + "static/media/rocket_anim_118.f13cbd6c.png";